var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel has-background-dark tile-border" },
    [
      _c(
        "p",
        {
          staticClass:
            "panel-heading has-text-centered has-text-white custom-panel-heading",
        },
        [_vm._v("LATEST RELEASES")]
      ),
      _c("DashboardProgressBar", {
        attrs: {
          "is-loading": false,
          "initial-color": "#53B700",
          "loading-color": "#53B700",
        },
      }),
      _c(
        "div",
        {
          staticClass:
            "content release-notes-content has-background-dark tile-border p-3",
        },
        [
          _vm._l(_vm.dashboardReleases, function (release, index) {
            return _c("div", { key: index }, [
              _c("div", { staticClass: "is-size-7 is-italic has-text-grey" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$filters.formatDateLocale(
                        release.date,
                        _vm.$user.info.locale
                      )
                    ) +
                    " "
                ),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-align-items-center is-justify-content-space-between",
                },
                [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "has-text-weight-bold is-size-6 mr-2" },
                      [_vm._v(_vm._s(release.title))]
                    ),
                    index === 0
                      ? _c("span", { staticClass: "tag is-success" }, [
                          _vm._v("New"),
                        ])
                      : _vm._e(),
                  ]),
                  release.link
                    ? _c("div", [
                        _c(
                          "a",
                          { attrs: { href: release.link, target: "_blank" } },
                          [
                            _vm._m(0, true),
                            _c(
                              "span",
                              { staticClass: "has-text-success is-size-6" },
                              [_vm._v("View")]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "ul",
                { staticClass: "pb-4 is-size-7" },
                _vm._l(release.notes, function (note, noteIndex) {
                  return _c("li", { key: noteIndex }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.formatNote(note)) },
                    }),
                  ])
                }),
                0
              ),
            ])
          }),
          _c("div", { staticClass: "has-text-centered" }, [
            _c(
              "a",
              { attrs: { href: "#" }, on: { click: _vm.displayAllReleases } },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "has-text-success is-size-7 has-text-weight-bold is-underlined",
                  },
                  [_vm._v("View All")]
                ),
              ]
            ),
          ]),
        ],
        2
      ),
      _vm.isReleaseModalActive
        ? _c(
            "ReleaseNotesModal",
            {
              attrs: { active: _vm.isReleaseModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isReleaseModalActive = $event
                },
                close: _vm.closeModal,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Release Notes"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "has-text-success mr-1" }, [
      _c("i", { staticClass: "mdi mdi-open-in-new mdi-14px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }